import { atom, selector } from 'recoil';
import { LocalAgreementService } from 'api';
export const localAgreementCustomerId = atom({
  key: 'localAgreementCustomerId',
  default: ''
});
export const localAgreementPagination = atom({
  key: 'localAgreementPagination',
  default: {
    max: 5,
    offset: 0
  }
});
export const localAgreementRequestId = atom({
  key: 'localAgreementRequestId',
  default: 0
});
export default selector({
  key: 'getLatestLocalAgreementsForCustomer',
  get: async ({
    get
  }) => {
    const customerId = get(localAgreementCustomerId);
    if (!customerId) return {};
    const pagination = get(localAgreementPagination);
    get(localAgreementRequestId);
    try {
      return await LocalAgreementService.getLatestLocalAgreementsByCustomerId({
        customerId,
        body: pagination
      });
    } catch (e) {
      console.log(e);
    }
    return {};
  }
});